<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的发票 -->
          <div class="ttshop_coupon min_h">
            <div class="ttshop_couponnav">
              <ul class="clearfloat">
                <li @click="invoiceTab(0)" :class="{active:invoiceIndex ==0}">全部发票</li>
                <li @click="invoiceTab(2)" :class="{active:invoiceIndex ==2}">已开发票</li>
                <li @click="invoiceTab(1)" :class="{active:invoiceIndex ==1}">未开发票</li>
              </ul>
            </div>
            <!-- 暂无发票显示 -->
            <div class="ttshop_zuxiaofei" v-show="list==null">
              <img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
              <p>您目前暂无任何发票</p>
            </div>
            <!-- 发票列表 -->
            <div class="ttshop_invoice" v-show="list!=null">
              <div class="ttshop_invoicetitle clearfloat">
                <p class="ttshop_infirst">订单详情</p>
                <p class="ttshop_inlx">发票类型</p>
                <p class="ttshop_inzt">状态</p>
                <p class="ttshop_incz">操作</p>
              </div>
              <div class="ttshop_invoicecon">
                <div class="ttshop_invoicelist" v-for="(item ,index ) in list" :key="index">
                  <div class="ttshop_barterlistitle clearfloat">
                    <p>{{item.addtime}}</p>
                    <p>订单号：<span>{{item.order_no}}</span></p>
                    <p>卖家：<strong>{{item.mch.name}}</strong></p>
                  </div>
                  <div class="ttshop_invoiceconter clearfloat d-flex">
                    <div class="ttshop_invoiceconterleft">
                      <div class="ttshop_invoiceconterlefts clearfloat" v-for="(items,idx) in item.order.detail" :key="idx">
                        <div class="ttshop_inleft clearfloat">
                          <div class="ttshop_inleftimg">
                            <img class="img-default" :src="items.goods.cover_pic" alt="">
                          </div>
                          <div class="ttshop_inleftext">
                            <h5>{{items.goods.name}}</h5>
                            <span v-for="(attr,ids) in items.attr" :key="ids">{{attr.attr_group_name}}:<strong>{{attr.attr_name}}</strong></span>
                          </div>
                        </div>
                        <div class="ttshop_incon">
                          <p>¥ {{items.total_price}}</p>
                        </div>
                        <div class="ttshop_incon">
                          <p>{{items.num}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="ttshop_invoiceconed d-flex  align-items-center justify-content-center">
                      <p v-if="item.head_type==1" style="margin-right:10px">个人级</p>
                      <p v-else-if="item.head_type==2"  style="margin-right:10px">企业级</p>
                      <p v-if="item.invoice_type==0">普通发票</p>
                      <p v-if="item.invoice_type==1">增值税普通票</p>
                      <p v-if="item.invoice_type==2">增值税专用票</p>
                    </div>
                    <div class="ttshop_invoiceconright d-flex  align-items-center justify-content-center">
                      <p class="yikai" v-show="item.status ==2">已开发票</p>
                      <p class="weikai" v-show="item.status == 1">未开发票</p>
                    </div>
                    <div class="ttshop_invoiceconrights d-flex  align-items-center justify-content-center">
                      <p @click="goTtshop_invoicexq(item.id)">发票详情</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ttshop_myorderpage clearfloat" v-show="pageShow">
              <el-pagination class="ttshop_pages" background layout="prev, pager, next" @prev-click="pages_perv" @next-click="page_next" :page-count="page_count"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      list: "",
      invoiceIndex: 0,
      page_count: 0,
      page: 1,
      pageShow: false,
    };
  },
  mounted() {
    this.getinvoiceList();
  },
  methods: {
    // 列表
    getinvoiceList() {
      this.$api
        .invoiceLists({
          status: this.invoiceIndex,
          page: this.page,
        })
        .then((res) => {
          // console.log(res.data);
          for(let i in res.data.list){
            for(let j in res.data.list[i].order.detail){
              if(res.data.list[i].order.detail[j].attr){
                res.data.list[i].order.detail[j].attr=JSON.parse(res.data.list[i].order.detail[j].attr)
              }
            }
          }
          this.list = res.data.list;
          this.page_count = res.data.page_count;
          if (res.data.page_count > 1) {
            this.pageShow = true;
          }
        })
        .catch((err) => {
          console.log(err);
          // this.user = err;
        });
    },
    //切换
    invoiceTab(index) {
      if (this.invoiceIndex != index) {
        this.invoiceIndex = index;
        this.page = 1;
        this.getinvoiceList();
      }
    },
    //上一页
    pages_perv() {
      this.page--;
      this.getinvoiceList();
    },
    // 下一页
    page_next() {
      this.page++;
      this.getinvoiceList();
    },
    // 详情
    goTtshop_invoicexq(id){
      this.$router.push({ path: "/ttshop_invoicexq", query: { id: id } });
    }
  },
};
</script>

<style  lang="scss" scoped>
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .ttshop_couponnav {
    width: 100%;
    margin-bottom: 20px;
    ul {
      li {
        float: left;
        cursor: pointer;
        padding-bottom: 10px;
        margin-right: 24px;
        box-sizing: border-box;
        position: relative;
        font-size: 12px;
        line-height: 12px;
        color: #333;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        &:last-child {
          margin-right: 0;
        }
        &::before {
          content: "";
          width: 00%;
          height: 2px;
          background: #ff0e25;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          -o-transform: translateX(-50%);
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;
        }
        &:hover {
          color: #ff0e25;
        }
        &:hover::before {
          width: 100%;
        }
        &.active {
          color: #ff0e25;
        }
        &.active:before {
          width: 100%;
        }
      }
    }
  }
  .ttshop_zuxiaofei {
    width: 100%;
    padding-top: 150px;
    box-sizing: border-box;
    img {
      display: block;
      width: 93px;
      height: 80px;
      margin: 0 auto 20px;
    }
    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }
  .ttshop_invoice {
    width: 100%;
    .ttshop_invoicetitle {
      width: 100%;
      height: 32px;
      background: #f5f5f5;
      line-height: 32px;
      margin-bottom: 20px;
      p {
        float: left;
        font-size: 12px;
        color: #333;
        font-weight: 400;
        text-align: center;
      }
      .ttshop_infirst {
        width: 50%;
      }
      .ttshop_inlx {
        width: 20%;
      }
      .ttshop_inzt {
        width: 15%;
      }
      .ttshop_incz {
        width: 15%;
      }
    }
    .ttshop_invoicecon {
      width: 100%;
      .ttshop_invoicelist {
        width: 100%;
        margin-bottom: 20px;
        .ttshop_barterlistitle {
          width: 100%;
          height: 32px;
          background: #f5f5f5;
          padding: 0 20px;
          box-sizing: border-box;
          p {
            float: left;
            font-size: 12px;
            color: #999;
            padding-top: 8px;
            box-sizing: border-box;
            margin-right: 24px;
            &:last-child {
              margin-right: 0;
            }
            span {
              font-size: 12px;
              color: #999;
            }
            strong {
              font-size: 12px;
              color: #333;
              font-weight: 500;
            }
          }
        }
        .ttshop_invoiceconter {
          width: 100%;
          border: 1px solid #ebebeb;
          border-top: 0;
          box-sizing: border-box;
          .ttshop_invoiceconterleft {
            float: left;
            width: 50%;
            .ttshop_invoiceconterlefts {
              height: 112px;
              border-bottom: 1px solid #ebebeb;
              box-sizing: border-box;
              &:last-child {
                border-bottom: 0;
              }
            }
            .ttshop_inleft {
              float: left;
              padding: 16px 20px;
              box-sizing: border-box;
              .ttshop_inleftimg {
                float: left;
                width: 80px;
                height: 80px;
                margin-right: 12px;
                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
              .ttshop_inleftext {
                float: left;
                width: 180px;
                h5 {
                  font-size: 12px;
                  color: #333;
                  line-height: 18px;
                  font-weight: 400;
                  margin-bottom: 8px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
                span {
                  font-size: 12px;
                  color: #999;
                  margin-right: 5px;
                  strong {
                    font-size: 12px;
                    color: #999;
                    font-weight: 400;
                  }
                  &:last-child {
                    margin-right: 0;
                  }
                }
              }
            }
            .ttshop_incon {
              float: left;
              width: 17%;
              padding-top: 16px;
              box-sizing: border-box;
              text-align: center;
              p {
                font-size: 12px;
                color: #333;
                line-height: 18px;
              }
            }
          }
          .ttshop_invoiceconed {
            float: left;
            width: 20%;
            text-align: center;
            border-left: 1px solid #ebebeb;
            box-sizing: border-box;
            p {
              font-size: 12px;
              color: #999;
              font-weight: 400;
              line-height: 18px;
            }
          }
          .ttshop_invoiceconright {
            float: left;
            width: 15%;
            text-align: center;
            border-left: 1px solid #ebebeb;
            box-sizing: border-box;
            .yikai {
              font-size: 12px;
              color: #3ccb4a;
              font-weight: 400;
              line-height: 18px;
            }
            .weikai {
              font-size: 12px;
              color: #cb3c3c;
              font-weight: 400;
              line-height: 18px;
            }
          }
          .ttshop_invoiceconrights {
            float: left;
            width: 15%;
            text-align: center;
            border-left: 1px solid #ebebeb;
            box-sizing: border-box;
            p {
              cursor: pointer;
              font-size: 12px;
              color: #333;
              font-weight: 400;
              line-height: 18px;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;
              &:hover {
                color: #ff0e25;
              }
            }
          }
        }
      }
    }
  }
  .ttshop_myorderpage {
    width: 100%;
    margin-top: 32px;
    .ttshop_pages {
      float: right;
    }
  }
}
</style>
